// extracted by mini-css-extract-plugin
export default {"header":"ResetPassword_header__kxlLq","form":"ResetPassword_form__U0FZw"};